import { shape, number, string } from 'prop-types';

export const BrandEngagementStats = shape({
  id: number,
  search_impressions: number,
  station_impressions: number,
  station_visits: number,
  avg_dwell_time: number,
  gas_prices_spotted: number,
  total_reviews: number,
  competitive_index: number,
  brand_engagement: number,
});

export const HourlyStat = shape({
  hour: string,
  value: number,
});
